import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map, Observable, switchMap } from 'rxjs';

import { AuthGroupService } from '../../auth-group/+state/auth-group.service';
import { InitializeAuthGroupSignal } from '../../auth-group/+state/auth-group.signals';
import { AUTH_GROUPS } from '../../auth-group/constants';

export const EXCEPTION_REPORTING_OFFICER_GROUPS = [
  AUTH_GROUPS.GUARDIAN_OF_SAFE_WORKING_HOURS,
  AUTH_GROUPS.DIRECTOR_OF_MEDICAL_EDUCATION,
  AUTH_GROUPS.HR_MEDICAL_STAFFING_ACCESS,
];

@Injectable({ providedIn: 'root' })
export class ExceptionReportingAuthGuardService {
  private authGroupService = inject(AuthGroupService);
  private router = inject(Router);
  private store = inject(Store);

  canActivate(): Observable<boolean | UrlTree> {
    this.store.dispatch(new InitializeAuthGroupSignal({}));
    return this.authGroupService.isLoaded().pipe(
      filter((isLoaded) => isLoaded),
      switchMap(() =>
        this.authGroupService.getOfficerBelongsToAnyOfTheAuthGroups(
          EXCEPTION_REPORTING_OFFICER_GROUPS,
        ),
      ),
      first(),
      map((isErOfficer) => (isErOfficer ? true : this.router.parseUrl('/dashboard'))),
    );
  }
}
